import React from "react";
import { formatDate, statusDotClass, truncate } from "./utils";
import { User, Calendar, Eye, ThumbsUp } from "lucide-react";

function MetaItem({ icon: Icon, children }) {
  return (
    <span className="bi-metaItem">
      <Icon className="bi-metaIcon" aria-hidden="true" />
      <span>{children}</span>
    </span>
  );
}

export default function IdeaCard({ idea, onOpen }) {
  return (
    <div
      className="bi-item"
      onClick={() => onOpen(idea)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onOpen(idea);
      }}
    >
      <div>
        <div className="bi-id"># {idea.ID}</div>
        <div className="bi-title">{idea.Title}</div>
        <div className="bi-desc">{truncate(idea.Description, 180)}</div>

        <div className="bi-meta">
          <MetaItem icon={User}>{idea["Submitter name"] || "—"}</MetaItem>

          <span className="bi-metaSep" aria-hidden="true">
            |
          </span>

          <MetaItem icon={Calendar}>{formatDate(idea._submittedAt)}</MetaItem>

          {idea.Department ? (
            <>
              <span className="bi-metaSep" aria-hidden="true">
                |
              </span>
              <span className="bi-pill is-dept">{idea.Department}</span>
            </>
          ) : null}

          {idea.Category ? (
            <>
              <span className="bi-metaSep" aria-hidden="true">
                |
              </span>
              <span className="bi-pill is-cat">{idea.Category}</span>
            </>
          ) : null}
        </div>
      </div>

      <div className="bi-right">
        <div className="bi-status">
          <span className={statusDotClass(idea._statusKey)} />
          {idea._statusKey}
        </div>

        <div className="bi-metrics">
          <span className="bi-metric">
            <Eye className="bi-metricIcon" aria-hidden="true" />
            <span>{idea._visits}</span>
          </span>

          <span className="bi-metricSep" aria-hidden="true">
            |
          </span>

          <span className="bi-metric">
            <ThumbsUp className="bi-metricIcon" aria-hidden="true" />
            <span>{idea._likes}</span>
          </span>
        </div>
      </div>
    </div>
  );
}
